export default __webpack_public_path__ + "static/media/3EstudiantesIes_combinado.bc641cd6.png";